'use strict';

var button = {};

exports.__exports = button;
//# sourceMappingURL=button3.cjs.map
